import React from 'react';
import { Text } from '@opendoor/bricks/core';

export interface ErrorMessageProps {
  message?: string;
}

const DEFAULT_ERROR_MESSAGE = 'There was an error submitting your request. Please try again.';

/**
 * Error message.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <Text role="alert" color="red50" mt={6}>
    {message ?? DEFAULT_ERROR_MESSAGE}
  </Text>
);
